module.exports = __webpack_public_path__ + "static/custom_date-1567c4cfb0b9c81a63132926397cc796.png";